import CTAButtons from "./CTAButtons";

const defaultCaseStudy = {
  name: "Francesca",
  property: "2-bed apartment",
  before: "£1,500 pm",
  afterGross: "£2,800 to £4,600 pm",
  afterNet: "£1,915 to £3,146 pm",
  uplift: "+113%",
  quote: "I was a bit sceptical at first. I'd had the same tenant for years and didn't want the hassle of dealing with guests. But the flat was sitting empty half the week anyway. Truestays sorted the listing, the cleaning, all of it. I still block the dates when I need to stay there. The income's been better than the rent was, though it does fluctuate with the seasons. Mostly I just don't have to think about it.",
  img: "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/78aca3211_7.png",
  avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face",
};

export default function ManchesterLandlordProof({ config }) {
  const caseStudy = config?.caseStudy || defaultCaseStudy;
  return (
    <section style={{ backgroundColor: "#FFFFFF", padding: "clamp(60px,7vw,96px) clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 44 }}>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", marginBottom: 12, marginTop: 0 }}>
            Landlord story
          </p>
          <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(28px,4vw,44px)", letterSpacing: "-0.02em", lineHeight: 1.15, color: "#112215", margin: "0 auto 16px", maxWidth: 620 }}>
            What hands-off hosting actually looks like
          </h2>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 16, color: "#5C7268", lineHeight: 1.65, maxWidth: 540, margin: "0 auto" }}>
            One real landlord, real numbers, and what it's like day to day.
          </p>
        </div>

        {/* Case study — full width */}
        <div style={{ display: "grid", gridTemplateColumns: "0.9fr 1.1fr", borderRadius: 16, overflow: "hidden", border: "1px solid #E8E4D5", background: "#F4F1E7" }} className="lp-case-grid">
          {/* Image */}
          <div style={{ minHeight: 340, background: "#E5E5E5" }}>
            <img src={caseStudy.img} alt={caseStudy.name} loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", minHeight: 340 }} />
          </div>

          {/* Content */}
          <div style={{ padding: "36px 36px", display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 24 }}>
              <img src={caseStudy.avatar} alt={caseStudy.name} style={{ width: 52, height: 52, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
              <div>
                <p style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 16, color: "#112215", margin: 0 }}>{caseStudy.name}</p>
                <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, color: "#5C7268", margin: "2px 0 0" }}>{caseStudy.property.split(",")[0]}</p>
              </div>
            </div>

            {/* Simplified comparison row */}
            <div className="lp-earnings-card" style={{ display: "flex", alignItems: "center", gap: 12, padding: "16px 18px", background: "#FFFFFF", borderRadius: 12, border: "1px solid #E8E4D5", marginBottom: 18 }}>
              <div style={{ flex: 1 }}>
                <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 9, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em", color: "#8A9B92", margin: 0 }}>Before (AST)</p>
                <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 17, fontWeight: 700, color: "#8A9B92", margin: "3px 0 0", letterSpacing: "-0.01em" }}>{caseStudy.before}</p>
              </div>
              <span className="lp-earnings-arrow" style={{ fontFamily: "'Inter', sans-serif", fontSize: 18, color: "#B8B4A5" }}>&rarr;</span>
              <div style={{ flex: 1 }}>
                <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 9, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em", color: "#CD533B", margin: 0 }}>After (short-let)</p>
                <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, fontWeight: 700, color: "#CD533B", margin: "3px 0 0", letterSpacing: "-0.01em", lineHeight: 1.2 }}>{caseStudy.afterGross}</p>
                <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 10.5, color: "#D88B75", margin: "2px 0 0" }}>Net: {caseStudy.afterNet}</p>
              </div>
              <span className="lp-earnings-badge" style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, fontWeight: 700, color: "#CD533B", background: "#FED7C3", padding: "4px 11px", borderRadius: 100, whiteSpace: "nowrap" }}>{caseStudy.uplift}</span>
            </div>

            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14.5, color: "#112215", lineHeight: 1.65, margin: 0, fontStyle: "italic", flex: 1 }}>
              &ldquo;{caseStudy.quote}&rdquo;
            </p>
          </div>
        </div>

        {/* Badge row */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 16, marginTop: 36, flexWrap: "wrap" }}>
          <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, fontWeight: 600, color: "#555" }}>4.76 average on Airbnb (1,000+ reviews)</span>
          <span style={{ color: "#D5D5D5" }}>&middot;</span>
          <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, fontWeight: 600, color: "#555" }}>5.0 on Google (90+ reviews)</span>
          <span style={{ color: "#D5D5D5" }}>&middot;</span>
          <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, fontWeight: 600, color: "#555" }}>35,000+ stays managed</span>
        </div>

        <div style={{ display: "flex", justifyContent: "center", marginTop: 36 }}>
          <CTAButtons includeMicrocopy />
        </div>

        {/* Guest experience is now its own section */}
      </div>

      <style>{`
        @media (max-width: 768px) { .lp-case-grid { grid-template-columns: 1fr !important; } }
        @media (max-width: 768px) { .lp-guest-grid { grid-template-columns: 1fr !important; } }
        @media (max-width: 600px) {
          .lp-earnings-card { flex-direction: column !important; align-items: stretch !important; gap: 10px !important; }
          .lp-earnings-arrow { display: none !important; }
          .lp-earnings-badge { align-self: flex-start !important; }
        }
      `}</style>
    </section>
  );
}